module.exports = {"Atelier":"Atelier","Projets":"Projekte","Equipe":"Team","Contact":"Kontakt","Editeur":"Herausgeber","sarl":"GmbH","sa":"ag","plan-daccès":"Anfahrtsplan","voir-le-projet":"Zum Projekt","suivant":"vorwärts","précédent":"zurück","retour":"alle","Mail":"Email","Phone":"Telefon","video-title":"AAS Architecture SA: Architektur als Kunst des Massgeschneiderten.","video-desc":"Ein Blick von Le Figaro auf eine anspruchsvolle Praxis, die auf die Nutzung, Materialien und Orte achtet.","video-link":"Link zum vollständigen Artikel (FR)"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/translations/de.json
// module id = PYq7
// module chunks = 1